<template>
  <q-scroll-area style="height: calc(100vh - 420px) !important">
    <div v-if="gridData.length > 0" class="q-px-md">
      <q-card
        bordered
        flat
        class="q-pa-md q-my-md"
        v-for="(event, index) in gridData"
        :key="`event_${index}`"
        v-if="event.lanes.length > 0"
      >
        <b>{{ event.event_no }} - {{ event.event_name }}</b> <br />
        <span
          >{{
            event.round_name.includes("Round")
              ? event.round_name
              : event.round_name.split(" 1")[0]
          }}
          - {{ event.race_index + 1 }}</span
        >
        <datatable
          :filter="search"
          :flat="true"
          :data="event.lanes"
          :columns="[
            {
              name: 'placing',
              label: 'Placing',
              field: 'placing',
              align: 'left',
              sortable: true,
            },
            {
              name: 'team_name',
              label: 'Participant',
              field: 'team_name',
              align: 'left',
              style:
                'min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;',
              sortable: true,
            },
            {
              name: 'association_abbr',
              label: 'Club',
              field: 'association_abbr',
              align: 'left',
              style:
                'min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;',
              sortable: true,
            },
            {
              name: 'master_time',
              label: 'Time',
              field: 'master_time',
              align: 'left',
              style:
                'min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;',
              sortable: true,
            },
            {
              name: 'points',
              label: 'Points',
              field: 'points',
              align: 'left',
              style:
                'min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;',
              sortable: true,
            },
          ]"
          @rowDoubleClick="handleDoubleClick"
        >
          <template slot="body-cell-association_abbr" slot-scope="data">
            <q-td :props="data.props">
              <q-img
                v-if="data.props.row.capUrl"
                :src="data.props.row.capUrl"
                width="40px"
                contain
                class="q-ml-sm"
              >
              </q-img>
              {{ data.props.row.association_abbr }}
            </q-td>
          </template>
        </datatable>
      </q-card>
    </div>
  </q-scroll-area>
</template>

<script>
  import datatable from "@/components/datatable/datatable.vue";

  export default {
    props: {
      gridData: [],
      search: {
        default: "",
        type: String,
      },
    },
    components: {
      datatable,
    },
    data() {
      return {};
    },
    methods: {
      handleDoubleClick(row) {
        console.log(row);
      },
    },
  };
</script>

<style>
</style>template
